import { ItemSource } from './source-section.model';
import { Pager } from '@sgm-frontend/core';
import { CustomerAddress } from '../customer/customer.model';
import { PaymentMethod } from './payment-method.model';
import { CatalogueInfoResponse, ProductVariant } from './product.model';

export interface OrdersResponse {
  orders: OrderInfo[];
}

export interface OneOrderResponse {
  order: OrderInfo;
}

export interface OrderInfo {
  status: string;
  id: number;
  customerId: number;
  subTotal: number;
  handlingFee: number;
  totalWithVat: number;
  vatAmount: number;
  shippingCost: number;
  orderStatus: string;
  date: Date;
  paymentStatus: string;
  shippingAddress: CustomerAddress;
  paymentMethod: PaymentMethod;
  orderItems: OrderItem[];
}

export interface OrderItem {
  id: number;
  quantity: number;
  orderPrice: number;
  product: CatalogueInfoResponse;
}


// new
export interface OrderListResponse extends Pager {
  records: OrderResponse[];

}
export interface SuccessOrderResponse {
  order: OrderResponse;
  payment_link: string;
}

export interface OrderResponse {
  id: string;
  coupon_code: string | null;
  sub_total: number;
  handling_fee: number;
  shipping_fee: number;
  discount: number;
  grand_total: number;
  payment_id: string;
  cached_customer_name: string;
  cached_payment_method: string;
  shipping_id: string | null;
  status: string;
  deleted_at: string | null;
  createdAt: string;
  invoice_url:string | null;
  order_address: OrderAddress;
  order_cancellations: OrderCancellationModel | null; // Assuming this could be null or another type
  payment: PaymentDetails | null;
  order_items: OrderItems[];
  tracking_order:TrackingHistory[];
  shipping_details:ShippingDetails | null;
  created_via:string;
  shipping_label:ShippingLabel | null;
}
export interface ShippingLabel {
  id: string;
  shipping_label: string ;
  order_id: string ;
}

export interface OrderCancellationModel {
   id: string;
  order_id: string;
  coupon_code?: string | null;
  subtotal: number;
  shipping_fee: number;
  discount: number;
  grand_total: number;
  cached_customer_name: string;
  cached_payment_method: string;
  reason: CancellationReason;
  status?: string; // Optional property
  other?: string;          // for custom reason text
  invoice_url: string;
  createdAt: string; 
  updatedAt?: string; // Optional property
  tracking_cancellation:TrackingHistory[];
}
export enum CancellationReason {
  change_of_mind = 'change_of_mind',
  found_better_price = 'found_better_price',
  delivery_delay = 'delivery_delay',
  purchased_from_branch = 'purchased_from_branch',
  financial_conditions = 'financial_conditions',
  incorrect_shipping_address = 'incorrect_shipping_address',
  incorrect_shipping_method = 'incorrect_shipping_method',
  incorrect_payment_information = 'incorrect_payment_information',
}

export interface OrderItems extends ItemSource {
  id: string;
  quantity: number;
  order_id : string;
  product_variant_id:string;
  returnable:boolean;
  unit_price: number;
  vat_amount?: string;
  vat_price?:number;
  product_variant: ProductVariant;
}
// payment.model.ts
export interface PaymentDetails {
  id: string;
  payment_method_id: string;
  payment_method?: payment_method | null;
  paid_at: string | null;
  additional_data: string | null;
  status: string;
  billing_address_id: string | null;
  reference_order_id: string;
}
export interface payment_method {
  id: string;
  code: string;
  is_active: boolean;
  name: string;
  createdAt: string;
  updatedAt: string;
}
export interface OrderAddress {
  order_id: string;
  latitude: number;
  longitude: number;
  first_name:string;
  last_name:string;
  email: string;
  mobile: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  state: string;
  country: string;
  note: string | null;
  createdAt: string;
  updatedAt: string;
}
export interface TrackingHistory {
  status: string;
  completed:boolean;
  event_date: string | null; // ISO date string, can use Date if parsed
}
export interface TrackingHistoryTimeline {
  slug:string;
  message:string;
  status: string;
  completed:boolean;
  event_date: string | null; // ISO date string, can use Date if parsed
}
export interface ShippingMethod {
  id: string;
  name: string;
  method_code: string;
  min_cart_total: string; // Use number if needed for calculations
}
export interface ShippingDetails {
  id: string;
  tracking_number: string | null;
  note: string | null;
   delivered_date: string | null;
  createdAt: string;
  shipping_method: ShippingMethod;
  shipping_company: ShippingCompany | null;
}
export interface ShippingCompany {
  id: string;
  name: string;
 is_active:boolean
}